import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot, orderBy } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

// Sanntidslytter på fakturaer for den innloggede brukeren (sjåfør eller bestiller)
export function useInvoices() {
  const { currentUser, effectiveRole } = useAuth();
  const [invoices, setInvoices]   = useState([]);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    if (!currentUser) return;

    const field = effectiveRole === 'driver' ? 'driverUid' : 'ordererUid';
    const q = query(
      collection(db, 'invoices'),
      where(field, '==', currentUser.uid),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(q, (snap) => {
      setInvoices(snap.docs.map(d => ({ id: d.id, ...d.data() })).filter(i => !i.kind));
      setLoading(false);
    });

    return unsubscribe;
  }, [currentUser, effectiveRole]);

  return { invoices, loading };
}

// Enkel hook for bestillerens faktura på et spesifikt oppdrag.
// Spørringen må filtrere på ordererUid (ikke bare orderId), ellers kan ikke sikkerhetsreglene bevise
// at alle treff er lesbare, og Firestore avviser hele spørringen.
export function useOrderInvoice(orderId) {
  const { currentUser } = useAuth();
  const uid = currentUser?.uid;
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orderId || !uid) return undefined;

    const q = query(
      collection(db, 'invoices'),
      where('orderId', '==', orderId),
      where('ordererUid', '==', uid),
    );
    const unsubscribe = onSnapshot(q, (snap) => {
      const card = snap.docs.map(d => ({ id: d.id, ...d.data() })).find(i => !i.kind);
      setInvoice(card ?? null);
      setLoading(false);
    }, (err) => {
      console.error('useOrderInvoice:', err);
      setInvoice(null);
      setLoading(false);
    });

    return unsubscribe;
  }, [orderId, uid]);

  return { invoice, loading };
}
